import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

export interface PlanCodeValidatorPayload {
  organization_id: string;
  plan_codes: string[];
}

export const usePlanCodeValidatorQuery = () => {
  const { mutateAsync, isLoading } = useMutation((newValue: Partial<PlanCodeValidatorPayload>) =>
    api.post(API_URL.PLANS_PLAN_CODES_VALIDATIONS, newValue)
  );

  const handleSave = async ({ orgId, codes }: { orgId?: string; codes: string[] }) => {
    const response = await mutateAsync({
      organization_id: orgId,
      plan_codes: codes,
    });
    return response?.data;
  };

  return {
    onSubmit: handleSave,
    isLoading,
  };
};
